module.exports = __webpack_public_path__ + "assets/icons/ic_menu_24px.svg";